import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
// eslint-disable-next-line object-curly-newline
import { Grid, Typography, Box } from '@material-ui/core';
import translate from '../../actions/translate';
import DesignAndLanguages from '../../components/DesignAndLanguages';
import LogoAndStepper from '../../components/LogoAndStepper';
import TopLayer from '../../components/layers/TopLayer';
import MiddleLayer from '../../components/layers/MiddleLayer';
import BottomLayer from '../../components/layers/BottomLayer';
import ViewPortContainer from '../../components/layers/ViewPortContainer';
import BoxContentContainer from '../../components/layers/BoxContentContainer';
import updateAnalytics from '../../actions/updateAnalytics';

export default function SeamlessForm() {
  const restaurantId = useSelector((state) => state.formState.Restaurant_id);

  const finalState = useSelector((state) => state.formState);

  useEffect(() => {
    updateAnalytics(
      {
        formComplete: true,
      },
      restaurantId
    );

    updateAnalytics(
      {
        finalState: finalState,
      },
      restaurantId
    );
  }, []);

  return (
    <ViewPortContainer>
      <TopLayer>
        <LogoAndStepper step={4} showStepper />
      </TopLayer>
      <MiddleLayer>
        <BoxContentContainer>
          <Typography variant="h4">{translate('Thank You!')} </Typography>
          <br />
          <Typography variant="h6">
            {translate(
              'Thank you for your interest in QMenu. An agent will call you shortly.'
            )}
          </Typography>
        </BoxContentContainer>
      </MiddleLayer>

      <BottomLayer>
        <DesignAndLanguages />
      </BottomLayer>
    </ViewPortContainer>
  );
}
